module.exports = __webpack_public_path__ + "components/panel/check-yeti/static/check-yeti-36407ab5dd87a6faaac0b61df8370562.webp";